import { Alert, Anchor, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage, defineMessages } from 'react-intl'

import { usePromotions } from 'hooks'
import React, { ReactNode } from 'react'

const messages = defineMessages({
  warning: { id: 'admin/promotions.limits.warning' },
  error: { id: 'admin/promotions.limits.exceeded' },
})

const ALERTS_METADATA = {
  warning: {
    message: messages.warning,
    helpLink:
      'https://help.vtex.com/tutorial/qual-o-limite-maximo-de-promocoes--frequentlyAskedQuestions_352',
  },
  critical: {
    message: messages.error,
    helpLink:
      'https://help.vtex.com/faq/mensagem-erro-the-limit-of-activated-calculators-has-been-reached--frequentlyAskedQuestions_349',
  },
}

export function AccountLimitsAlert() {
  const { data } = usePromotions()

  if (!data?.meta) return null

  const { usage, limit } = data.meta

  const usedQuota = usage / limit

  if (usedQuota < 0.9) return null

  const alertLevel = usedQuota >= 1 ? 'critical' : 'warning'

  const { message, helpLink } = ALERTS_METADATA[alertLevel]

  return (
    <Alert variant={alertLevel}>
      <FormattedMessage
        {...message}
        values={{
          current: usage,
          limit: limit,
          a: function Link(chunks: ReactNode[]) {
            return (
              <Anchor href={helpLink} target="_blank">
                {chunks}
              </Anchor>
            )
          },
          b: function Bold(chunks: React.ReactNode[]) {
            return (
              <Text className={csx({ fontSettings: 'medium' })}>{chunks}</Text>
            )
          },
        }}
      />
    </Alert>
  )
}
